import ThermometerIcon from './component'

export default ThermometerIcon
